import React from "react"
import { css } from "emotion"
import { EditorState, convertFromRaw } from "draft-js"
import humanReadableDaysAgo from "../util/humanReadableTimeAgo"
import type { Comment, Thread } from "../types"

function commentMessage(comment: Comment) {
	let jsonifiedCommentMessage = JSON.parse(comment.message)
	let messageConvertedFromRaw = convertFromRaw(jsonifiedCommentMessage)
	let tempEditorState = EditorState.createWithContent(messageConvertedFromRaw)
	let commentText = tempEditorState.getCurrentContent().getPlainText("\u0001")
	return commentText.replace("\u0001", " ")
}

export interface UpdateProps {
	comment: Comment
	threads: Thread[]
	threadIndex: number
	onOpen: (threadIndex: number) => void
}

export default function Update(props: UpdateProps) {
	function handleClick() {
		let scrollPosition = props.threads[props.threadIndex].y - 100
		window.scrollTo(0, scrollPosition)
		props.onOpen(props.threadIndex)
	}

	return (
		<div
			className={css`
				text-align: left;
				margin-bottom: 2em;
				margin-right: 0.5em;
				border-bottom: 1px solid #eaeaea;
				cursor: pointer;
			`}
			onClick={handleClick}
		>
			<div
				className={css`
					align-content: left;
					display: flex;
					flex-direction: row;
				`}
			>
				<img
					src={props.comment.author.avatar}
					className={css`
						align-content: flex-start !important;
						border-radius: 50% !important;
						height: 30px !important;
						width: 30px !important;
						margin-left: 2em;
					`}
				/>
				<div
					className={css`
						font-size: 12px;
						align-self: center;
						color: #2a3632;
						margin-left: 10px;
						font-weight: 500;
						font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont,
							"Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
							sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
							"Segoe UI Symbol", "Noto Color Emoji", Helvetica, Arial,
							sans-serif;
						text-align: left !important;
					`}
				>
					{props.comment.author.name} commented
				</div>
				<div
					className={css`
						align-self: center;
						color: #d8d8d8;
						font-size: 12px;
						margin-left: 10px;
						text-align: left !important;
						font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont,
							"Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
							sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
							"Segoe UI Symbol", "Noto Color Emoji", Helvetica, Arial,
							sans-serif;
					`}
				>
					{humanReadableDaysAgo(props.comment._id)}
				</div>
			</div>
			<div
				className={css`
					font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont,
						"Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
						"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
						"Noto Color Emoji", Helvetica, Arial, sans-serif;
					font-size: 12px;
					color: #2a3632;
					padding-left: 2em;
					padding-bottom: 20px;
					padding-top: 5px;
				`}
			>
				<div>{commentMessage(props.comment)} </div>
			</div>
		</div>
	)
}
